import { FC } from "react";

import { discountPercents } from "../../settings";
import { useStoreDispatch, useStoreSelector } from "../../store/store";

import './DiscountSelector.scss';


const DiscountSelector: FC = () => {

	const {discountPercent} = useStoreSelector(store => store.app);	
	const {setDiscountPercent} = useStoreDispatch();


	return (
		<div className="DiscountSelector">
			{discountPercents.map(percent => 
				percent === discountPercent?
					<div
						key={percent}
						className='DiscountSelector_value DiscountSelector_valueSelected'
					>
						<div className='DiscountSelector_valueSelected-text'>
							{percent}%
						</div>
					</div>
				:
					<div
						key={percent}
						className='DiscountSelector_value'
						onClick={() => setDiscountPercent(percent)}
					>
						{percent}%
					</div>
			)}
		</div>
	)
}

export default DiscountSelector;